import { render, staticRenderFns } from "./StudioAdminList.vue?vue&type=template&id=7c18c486"
import script from "./StudioAdminList.vue?vue&type=script&lang=js"
export * from "./StudioAdminList.vue?vue&type=script&lang=js"
import style0 from "./StudioAdminList.vue?vue&type=style&index=0&id=7c18c486&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports